import { useMemo } from "react";
import useForm from "./use-form/useForm";
import agent from "../agent";

const useCatalogSubform = (code, { control, errors, setValue }) => {
    const rows = useMemo(() => [
            [
                {
                    name: "tax",
                    label: "Вид налога/платежа",
                    placeholder: "Выберите значение",
                    inputType: "dropdown",
                    onOptionSelect: (option) => {
                        if (!option) {
                            return;
                        }

                        setValue("tax", option);

                        const {
                            basicValue,
                            amountIndicat,
                            startedAt,
                            endedAt,
                            maxIncome,
                            minIncome,
                            maxSum,
                            minSum
                        } = option;

                        const obj = {
                            basicValue,
                            amountIndicat,
                            startedAt,
                            endedAt,
                            maxIncome,
                            minIncome,
                            maxSum,
                            minSum
                        };

                        Object.entries(obj).forEach(async ([key, value]) => {
                            let formKey, formValue;

                            switch (key) {
                                case "basicValue":
                                    formKey = key;
                                    formValue = value.sign;
                                    break;
                                case "startedAt":
                                case "endedAt":
                                    formKey = [
                                        "tax",
                                        key.charAt(0).toUpperCase(),
                                        key.slice(1)
                                    ].join("");
                                    formValue = value ? new Date(value) : value;
                                    break;
                                case "maxSum":
                                case "minSum":
                                    formKey = key;

                                    const currentMZP = (await agent
                                        .AccountingDictionary
                                        .searchRecords(
                                            "indicators",
                                            { shortNameRu: "МЗП" },
                                            0,
                                            1
                                        ))
                                        .content[0]
                                        .amountIndicat;
                                    const referenceProp = key
                                        .slice(0, 3)
                                        .concat("Income");

                                    formValue = currentMZP * option[referenceProp];
                                    break;
                                default:
                                    formKey = key;
                                    formValue = value;
                                    break;
                            }

                            setValue(formKey, formValue);
                        })
                    }
                },
            ],
            [
                {
                    name: "basicValue",
                    label: "Базовая величина",
                    disabled: true,
                    placeholder: "Автозаполнение"
                },
                {
                    name: "amountIndicat",
                    label: "Размер",
                    disabled: true,
                    placeholder: "Автозаполнение"
                },
            ],
            [
                {
                    name: "taxStartedAt",
                    label: "Дата начала действия",
                    disabled: true,
                    placeholder: "ДД.ММ.ГГГГ",
                    inputType: "date",
                },
                {
                    name: "taxEndedAt",
                    label: "Дата окончания действия",
                    disabled: true,
                    placeholder: "ДД.ММ.ГГГГ",
                    inputType: "date",
                },
            ],
            [
                {
                    name: "maxIncome",
                    label: "Максимальный доход, количество МЗП",
                    disabled: true,
                    placeholder: "Автозаполнение",
                    inputType: "number",
                },
                {
                    name: "minIncome",
                    label: "Минимальный доход, количество МЗП",
                    disabled: true,
                    placeholder: "Автозаполнение",
                    inputType: "number",
                },
            ],
            [
                {
                    name: "maxSum",
                    label: "Сумма макс.",
                    disabled: true,
                    placeholder: "Автоматический расчет",
                    inputType: "number",
                },
                {
                    name: "minSum",
                    label: "Сумма мин.",
                    disabled: true,
                    placeholder: "Автоматический расчет",
                    inputType: "number",
                },
            ],
            [
                {
                    name: "taxActivity",
                    label: "Активен",
                    disabled: true,
                    inputType: "boolean",
                }
            ]
        ]
            .filter(row => row && typeof row === "object")
            .map(row => row.filter(elem => typeof elem === "object"))
            .filter(row => row.length),
        [setValue]
    );

    return useForm(code, rows, { control, errors });
}

export default useCatalogSubform;